import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const DeleteQuerySlice = createSlice({
    name: "deleteQueryRequest",
    initialState,
    reducers: {
        deleteQueryRequest(state) {
            state.loading = true;
        },
        deleteQueryRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        deleteQueryRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        deleteQueryStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    deleteQueryRequest,
    deleteQueryRequestSuccess,
    deleteQueryRequestError,
    deleteQueryStateReset,
} = DeleteQuerySlice.actions;

export default DeleteQuerySlice.reducer;
